import { render, staticRenderFns } from "./KidCategorySkills.vue?vue&type=template&id=0f760ba3&scoped=true"
import script from "./KidCategorySkills.vue?vue&type=script&lang=js"
export * from "./KidCategorySkills.vue?vue&type=script&lang=js"
import style0 from "./KidCategorySkills.vue?vue&type=style&index=0&id=0f760ba3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f760ba3",
  null
  
)

export default component.exports